import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// React Native 앱과 동일한 Firebase 설정 사용 (데이터 공유)
const firebaseConfig = {
  apiKey: "AIzaSyA0PEQslTa-cM4kgfy9ubt-jYu9aNtD50Q",
  authDomain: "scanvcf.com",
  projectId: "scanvcf-375fb",
  storageBucket: "scanvcf-375fb.firebasestorage.app",
  messagingSenderId: "603606213699",
  appId: "1:603606213699:android:131f4e659f55a7b0f020f6"
};

// 웹 전용 Firebase 앱 초기화 (강제로 새 앱 생성)
let app;
try {
  // 기존 앱들을 모두 삭제하고 새로 시작
  const existingApps = getApps();
  existingApps.forEach(existingApp => {
    console.log('🗑️ Removing existing Firebase app:', existingApp.name);
  });
  
  // 새 앱 초기화
  app = initializeApp(firebaseConfig);
  console.log('✅ New Firebase app initialized with authDomain:', firebaseConfig.authDomain);
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  // 폴백: 새 앱 생성
  app = initializeApp(firebaseConfig, 'web-app');
  console.log('🔄 Fallback Firebase app created');
}

// Firebase 서비스 초기화
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// 개발 환경에서 에뮬레이터 연결 (선택사항)
if (process.env.NODE_ENV === 'development' && process.env.USE_FIREBASE_EMULATOR === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('🔧 Firebase emulators connected');
  } catch (error) {
    console.log('⚠️ Firebase emulators not available');
  }
}

// Firebase 앱 상태 확인
console.log('🌐 Web Firebase Status:', {
  appName: app.name,
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain
});

export default app; 